const carouselItems = [
  {
    id: 1,
    title: '年度娱乐圈十大名场面',
    desc: '回顾今年最令人印象深刻的娱乐圈名场面，从红毯造型到综艺翻车，从发布会金句到片场花絮，每一个都是吃瓜人必看的经典瞬间。',
    label: '年度盘点',
    image: 'https://readdy.ai/api/search-image?query=Grand%20award%20ceremony%20stage%20with%20dramatic%20spotlights%20and%20golden%20confetti%2C%20warm%20coral%20and%20amber%20lighting%2C%20elegant%20theater%20atmosphere%2C%20prestigious%20entertainment%20event%20aesthetic%2C%20cinematic%20wide%20shot%20composition&width=1000&height=650&seq=carousel-01-yearend&orientation=landscape',
  },
  {
    id: 2,
    title: '热播剧终极剧情预测',
    desc: '年度大剧即将迎来高潮，各路分析师纷纷押注结局走向。我们整理了最靠谱的五大预测，结合原著细节与前情伏笔，带你预判最终章。',
    label: '深度分析',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20film%20set%20with%20warm%20cinematic%20lighting%20and%20director%20chair%20silhouette%2C%20soft%20coral%20and%20cream%20tones%2C%20behind%20the%20scenes%20aesthetic%2C%20movie%20production%20atmosphere%20with%20elegant%20composition&width=1000&height=650&seq=carousel-02-drama&orientation=landscape',
  },
  {
    id: 3,
    title: '短视频平台网红生态观察',
    desc: '深度解析当前短视频平台网红竞争格局，从内容创作趋势到商业化变现路径，从流量密码到粉丝经济，全方位揭示网红圈的生存法则与发展方向。',
    label: '行业观察',
    image: 'https://readdy.ai/api/search-image?query=Modern%20content%20creator%20studio%20with%20ring%20light%20and%20camera%20setup%2C%20warm%20ambient%20glow%20with%20coral%20accents%2C%20creative%20workspace%20aesthetic%2C%20professional%20video%20production%20environment%2C%20clean%20minimal%20design&width=1000&height=650&seq=carousel-03-creator&orientation=landscape',
  },
  {
    id: 4,
    title: '国际娱乐产业年度报告',
    desc: '从好莱坞到K-pop，从流媒体大战到线下演出复苏，盘点全球娱乐产业的最新动向与未来趋势。聚焦中国市场在国际娱乐版图中的角色变化。',
    label: '全球视野',
    image: 'https://readdy.ai/api/search-image?query=World%20entertainment%20industry%20collage%20with%20film%20reel%20and%20stage%20elements%2C%20warm%20golden%20and%20coral%20ambient%20lighting%2C%20international%20cinema%20aesthetic%2C%20sophisticated%20editorial%20style%2C%20global%20creative%20network%20concept&width=1000&height=650&seq=carousel-04-global&orientation=landscape',
  },
  {
    id: 5,
    title: '吃瓜必备防走失指南',
    desc: '全面解析51吃瓜网址的多线路访问机制与域名更新策略，教你如何收藏多个入口、识别官方通道、辨别仿冒网站。从此吃瓜不迷路，安全又省心。',
    label: '实用指南',
    image: 'https://readdy.ai/api/search-image?query=Digital%20compass%20and%20navigation%20concept%20with%20warm%20lighting%20on%20a%20clean%20desk%20surface%2C%20soft%20coral%20and%20cream%20tones%2C%20modern%20minimal%20tech%20aesthetic%2C%20bookmark%20and%20map%20elements%2C%20safe%20browsing%20concept%20composition&width=1000&height=650&seq=carousel-05-guide&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-foreground-600 text-sm md:text-base">深度策划的吃瓜专题，一站看尽热门焦点</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.slice(0, 3).map((item) => (
            <article
              key={item.id}
              className="bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-200/50 transition-all duration-300 group cursor-pointer flex flex-col"
            >
              <div className="relative w-full aspect-[16/10] bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const el = e.currentTarget;
                    el.style.display = 'none';
                    if (el.parentElement) el.parentElement.style.display = 'none';
                  }}
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <span className="inline-block px-2.5 py-1 rounded-md bg-accent-100 text-accent-700 text-xs font-medium mb-3 w-fit">
                  {item.label}
                </span>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 mt-4 md:mt-5">
          {carouselItems.slice(3, 5).map((item) => (
            <article
              key={item.id}
              className="bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-200/50 transition-all duration-300 group cursor-pointer flex flex-col md:flex-row"
            >
              <div className="relative w-full md:w-[45%] aspect-[16/10] md:aspect-auto bg-background-200 overflow-hidden flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const el = e.currentTarget;
                    el.style.display = 'none';
                    if (el.parentElement) el.parentElement.style.display = 'none';
                  }}
                />
              </div>
              <div className="p-5 flex flex-col flex-1 justify-center">
                <span className="inline-block px-2.5 py-1 rounded-md bg-accent-100 text-accent-700 text-xs font-medium mb-3 w-fit">
                  {item.label}
                </span>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}